import { createAsyncThunk } from '@reduxjs/toolkit';
import { AsyncThunkAPI } from 'Redux/types';

import uiSlice from 'Redux/slices/ui';
import Atc from '../../../../Lib/ATC';

export interface IForgetPasswordThunkParams {
    email: string;
}

export interface IForgetPasswordThunkResponse {
    error: boolean;
    errorMessage?: string;
}

export default createAsyncThunk<
    IForgetPasswordThunkResponse,
    IForgetPasswordThunkParams,
    AsyncThunkAPI
>('auth/resetPasswordRequest', async (params, thunkAPI) => {
    const { email } = params;

    const response = await thunkAPI.extra.useCases.auth.resetPasswordRequest.execute({ email, role: 4 });

    if (response.status === Atc.UseCases.Types.UseCaseResponseStatus.Success) {
        if (response.data.error) {
            return thunkAPI.rejectWithValue('Something went wrong, plese try again');
        }
        thunkAPI.dispatch(uiSlice.actions.uiSetIsEmailSent(true));
        thunkAPI.dispatch(uiSlice.actions.uiSetForgetPasswordEmail(email));
        return response.data;
    }

    if (response.status === Atc.UseCases.Types.UseCaseResponseStatus.Error) {
        return thunkAPI.rejectWithValue('Something went wrong, please try again');
    }

    return thunkAPI.rejectWithValue('Something went wrong, please try again');
});
